import inboxes from "./inboxes";

const inboxService = [
    {
        matcher: 'inboxes',
        reply: config => {
            return [200, inboxes];
        }
    },
    {
        matcher: /inboxes\/(.*)/,
        reply: config => {
            const id = /inboxes\/(.*)/.exec(config.url)[1];
            const inbox = inboxes.find(inbox => inbox.id === id);
            return [200, inbox];
        }
    }
]

export default inboxService;